import React, { useCallback, useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { useFormik } from 'formik';

import { PHONE_MASK_FORMAT, SIGNUP_PATHS } from '../../../../constants';
import CodeInput from '../../../../modules/code-input';
import IconBtn from '../../../../modules/icon-btn/icon-btn';
import { useAppDispatch } from '../../../../store';
import { registrationCode } from '../../../../store/actions/signup';
import { RootState } from '../../../../types';
// import { useUserToken } from "../../../../hooks/userTokenHook";
import { REGISTRATION_STEP_STATUS } from '../../../../types';
import FormFooter from '../form-footer/form-footer';
import FormHeader from '../form-header/form-header';
import UserIcon from '../icons/user-icon.svg';

type FormStateType = {
  code?: string;
};

const initialState: FormStateType = {
  code: '',
};

const CodeStep: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [disabledBtn, setDisabledBtn] = useState(false);
  const signupStorage = useSelector((s: RootState) => s.signup);

  const resultRouterCallback = useCallback((step: REGISTRATION_STEP_STATUS) => {
    switch (step) {
      case 'PERSONAL_DATA_INPUT':
        history.push(SIGNUP_PATHS.PERSON_SELECT);
        break;
      // case 'PERSONAL_DATA_INPUT':
      //   history.push(SIGNUP_PATHS.INFO);
      //   break;
      case 'ORGANIZATION_DATA_UPLOADING':
        history.push(SIGNUP_PATHS.DOCS);
        break;
      case 'ACCESSION_AGREEMENT':
        history.push(SIGNUP_PATHS.AGREEMENT);
        break;
      case 'PASSWORD_CREATION':
        history.push(SIGNUP_PATHS.PASSWORD);
        break;
      default:
        break;
    }
  }, []);

  const formState = useFormik({
    initialValues: initialState,
    validate: (values) => {
      const errors: Record<string, string> = {};
      if (
        signupStorage.codeLength &&
        values.code &&
        values.code.length < signupStorage.codeLength
      ) {
        errors.code = 'Введите код';
      }
      return errors;
    },
    onSubmit: (values) => {
      if (values.code) {
        setDisabledBtn(true);
        dispatch(
          registrationCode({
            code: values.code,
            cb: resultRouterCallback,
          })
        );
      }
    },
  });

  useEffect(() => {
    if (!signupStorage.phone || !signupStorage.registrationId)
      history.push(SIGNUP_PATHS.BASE);
  }, [signupStorage]);

  return (
    <form className="login-form login-form--2">
      <FormHeader
        bigTitle="Регистрация"
        title="Подтверждение номера"
        text={
          <>
            Мы отправили смс с проверочным кодом на ваш номер:
            <br />
            <NumberFormat
              value={signupStorage.phone}
              displayType="text"
              format={PHONE_MASK_FORMAT}
            />
          </>
        }
      />
      <div className="login-form__body">
        <div className="login-form__container-296">
          <CodeInput
            onInputFill={(fill) => {
              formState.setFieldValue('code', fill);
              formState.handleSubmit();
            }}
            inputLength={4}
          />
        </div>
        <div className="login-form__body-bottom">
          <div className="login-form__body-bottom-text">
            <p className="login-form__body-bottom-text">
              Если вы не получили код, нажмите отправить код
              <br />
              повторно по истечении 60 сек.
            </p>
            <a className="login-form__body-bottom-link" href="/">
              Отправить код повторно
            </a>
          </div>
        </div>
      </div>
      <FormFooter
        actions={
          <>
            <IconBtn
              disabled={disabledBtn || !formState.values.code}
              onClick={() => {
                formState.handleSubmit();
              }}
              icon={UserIcon}
              title="Продолжить"
              lg
            />
            <Link className="login-form__link" to="/login">
              Войти
            </Link>
          </>
        }
      />
    </form>
  );
};

export default CodeStep;
